import { gql, useMutation } from "@apollo/client";

import { GqlClientUserDeleteInput } from "~/__generated__";

import { CLIENT_USER_GET_ALL_WITH_ACCESS_TO_CLIENT } from "./useClientUserGetAllWithAccessToClient";

const CLIENT_USER_DELETE = gql(`
    mutation ClientUserDelete($input: GqlClientUserDeleteInput!) {
        clientUserDelete(input: $input)
    }
`);

export default function useClientUserDelete() {
    const [mutate, { loading, error, data }] = useMutation(CLIENT_USER_DELETE, {
        refetchQueries: [CLIENT_USER_GET_ALL_WITH_ACCESS_TO_CLIENT],
    });

    const deleteClientUser = (input: GqlClientUserDeleteInput) => mutate({ variables: { input } });

    return {
        deleteClientUser,
        loading,
        error,
        success: data?.clientUserDelete ?? false,
    };
}
